import {
	getConfigFieldsCrud,
	getConfigVoucher,
	getTableGlobalProviderAttr,
	providerAttrGlobalApply,
	providerAttrGlobalAssign,
	providerAttrGlobalAssignConfirm,
	providerAttrGlobalAssignEdit,
	providerAttrGlobalAssignPaginate,
	providerAttrIndividualApply,
	providerCleanButton,
	voucherCancel
} from 'actions'
import { P_PROVIDERS_ATTRIBUTES_GLOBAL_UPLOAD } from 'constants/ConfigProcessNames'
import { getFiltersData } from 'lib/Utils'
import { ICrudFieldStructure } from 'models/CrudInterface'
import {
	ICrudApplyProviderAttrFilters,
	ICrudApplyProviderAttrIndividual,
	ICrudProviderAttrGlobalAssignConfirm,
	IProviderAttributesGlobalUploadProps,
	IProviderAttributesGlobalUploadState
} from 'models/ProviderGlobalUploadInterface'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import { LANDING } from 'utils/RoutePath'
import ProviderAttributesGlobalUploadForm from './ProviderAttributesGlobalUploadForm'
import ProviderAttributesGlobalUploadTable from './ProviderAttributesGlobalUploadTable'

class ProviderAttributesGlobalUpload extends Component<
	IProviderAttributesGlobalUploadProps,
	IProviderAttributesGlobalUploadState
> {
	constructor(props: IProviderAttributesGlobalUploadProps) {
		super(props)
		this.state = {
			paramsSearch: {
				idOperacion: props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				orden: 1
			},
			attributesList: {
				lista: []
			},
			gridAttrList: {
				lista: []
			},
			showEditPopup: false,
			disableForm: false
		}
	}

	componentDidUpdate = (prevProps: IProviderAttributesGlobalUploadProps) => {
		const {
			providerAttrList,
			getTableGlobalProviderAttr,
			idOperacion,
			globalProviderAttr,
			providerAttrPagination,
			providerAttrIndividualAccept,
			providerAttrGlobalAssignPaginate,
			voucherTypeCancel,
			authUser
		} = this.props
		const {
			providerAttrList: prevProviderAttrList,
			globalProviderAttr: prevGlobalAttr,
			providerAttrIndividualAccept: prevProviderAttrIndividualAccept,
			providerAttrPagination: prevProviderAttrPagination,
			voucherTypeCancel: prevVoucherTypeCancel
		} = prevProps

		const { paramsSearch } = this.state

		if (prevProviderAttrList !== providerAttrList && providerAttrList) {
			getTableGlobalProviderAttr(idOperacion || 0)
		}

		if (prevGlobalAttr !== globalProviderAttr && globalProviderAttr) {
			this.handleAttribsValues(globalProviderAttr)
		}

		if (
			prevProviderAttrIndividualAccept !== providerAttrIndividualAccept &&
			providerAttrIndividualAccept
		) {
			providerAttrGlobalAssignPaginate(paramsSearch)
		}
		if (prevProviderAttrList !== providerAttrList && providerAttrList) {
			this.setState({
				gridAttrList: { ...providerAttrList }
			})
			this.setState({ disableForm: true })
		}
		if (
			prevProviderAttrPagination !== providerAttrPagination &&
			providerAttrPagination
		) {
			this.setState({
				gridAttrList: { ...providerAttrPagination }
			})
		}
		if (prevVoucherTypeCancel !== voucherTypeCancel && voucherTypeCancel) {
			this.props.history.push(`${LANDING}/${authUser.userCompany}`)
		}
	}

	handleFormApply = (values: ICrudApplyProviderAttrFilters) => {
		const { providerAttrGlobalApply, idOperacion } = this.props

		const newFilters = {
			...values,
			idOperacion: idOperacion || 0,
			page_size: 10,
			page_number: 1
		}
		providerAttrGlobalApply(newFilters)
		this.setState({
			paramsSearch: newFilters
		})
	}

	handleModalSubmit = (values: ICrudApplyProviderAttrIndividual) => {
		const { idOperacion } = this.props

		this.props.providerAttrIndividualApply({
			...values,
			idOperacion: idOperacion || 0
		})

		this.setState({ showEditPopup: false })
	}

	handleOpen = (cell: any, row: any) => {
		const { providerAttrGlobalAssignEdit, idOperacion } = this.props

		providerAttrGlobalAssignEdit({
			niprov: row.niprov,
			idOperacion: idOperacion || 0
		})

		this.setState((prevState) => ({
			showEditPopup: !prevState.showEditPopup
		}))
	}

	handleCloseEditPopup = () => {
		this.setState({ showEditPopup: false })
	}

	handleButtonSubmit = () => {
		const { page_size, page_number, orden } = this.state.paramsSearch
		const { idOperacion } = this.props

		const confirmGlobalAssign: ICrudProviderAttrGlobalAssignConfirm = {
			page_size: page_size,
			page_number: page_number,
			orden: orden,
			idOperacion: idOperacion || 0
		}

		this.props.providerAttrGlobalAssignConfirm(confirmGlobalAssign)
	}

	handleButtonClean = () => {
		this.setState({
			gridAttrList: {
				page_size: 10,
				page_number: 1,
				total_count: 0,
				lista: []
			},
			disableForm: false,
			paramsSearch: {
				idOperacion: this.props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				orden: 1
			}
		})
		this.props.providerCleanButton()
	}

	handleGlobalAssign = (values: any) => {
		const { page_size, page_number, orden } = this.state.paramsSearch
		const { idOperacion } = this.props

		const globalAssignValues = {
			idOperacion: idOperacion ?? 0,
			page_size: page_size,
			page_number: page_number,
			orden: orden,
			codigo: values.Atrib_asig,
			valor: values.atrib_valor || values.descrip_valor
		}

		this.props.providerAttrGlobalAssign(globalAssignValues)
	}

	handleChangeTable = (type: String, pagination: any) => {
		const { paramsSearch } = this.state
		const { providerAttrGlobalAssignPaginate, idOperacion } = this.props
		if (type === 'pagination') {
			providerAttrGlobalAssignPaginate({
				...paramsSearch,
				idOperacion: idOperacion || 0,
				page_size: pagination.sizePerPage,
				page_number: pagination.page,
				orden: paramsSearch.orden
			})
		}
	}

	handleAttribsValues = (attribs: any) => {
		this.setState({
			attributesList: {
				lista: attribs.lista
			}
		})
	}

	render() {
		const { t, config, providerAttrList, idOperacion } = this.props
		const { attributesList, disableForm, showEditPopup, gridAttrList } =
			this.state

		const tableFields = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []
		const modalFields = config
			? getFiltersData(config.campos, { agrupador: 'grupo.modal' })
			: []
		const attributesFields = []

		if (providerAttrList?.lista?.length > 0) {
			for (let it = 0; it < 5; it++) {
				const newField: ICrudFieldStructure = {
					idCampo: '',
					label: 'Atributo',
					descrip: 'Atributo',
					mascara: '',
					editable: false,
					visible: 1,
					requerido: false,
					valid: '',
					agrupador: 'atributo'
				}
				let fieldExists = false
				_.each(providerAttrList.lista, (item) => {
					if (
						item.listaAtribs[it] &&
						item.listaAtribs[it].cod_atrib !== '' &&
						!fieldExists
					) {
						newField.idCampo = item.listaAtribs[it].cod_atrib
						newField.label = item.listaAtribs[it].desc_atrib
						newField.descrip = item.listaAtribs[it].cod_atrib

						fieldExists = true
					}
				})

				if (fieldExists) attributesFields.push(newField)
			}
		}

		const formProps = {
			fields: config.campos,
			t: t,
			handleButtonSubmit: this.handleButtonSubmit,
			handleSubmit: this.handleFormApply,
			handleGlobalAssign: this.handleGlobalAssign,
			attributesList: attributesList,
			disableForm: disableForm,
			idOperacion: idOperacion,
			handleButtonClean: this.handleButtonClean
		}

		const tableProps = {
			idOperacion: idOperacion || 0,
			tableFields: [...tableFields, ...attributesFields],
			modalFields: [...modalFields, ...attributesFields],
			t: t,
			disableForm: true,
			handleModalSubmit: this.handleModalSubmit,
			handleChangeTable: this.handleChangeTable,
			fields: gridAttrList,
			handleCloseEditPopup: this.handleCloseEditPopup,
			showEditPopup: showEditPopup,
			handleOpen: this.handleOpen
		}

		return (
			<>
				<ProviderAttributesGlobalUploadForm {...formProps} />
				<ProviderAttributesGlobalUploadTable {...tableProps} />
			</>
		)
	}
}
const mapStateToProps = ({
	voucher,
	auth,
	configCrud,
	providerAttrGlobalUpload,
	tableCalls
}: any) => {
	const config = voucher.config
		? voucher.config[P_PROVIDERS_ATTRIBUTES_GLOBAL_UPLOAD]
		: null

	const { fieldsConfig } = configCrud
	const { authUser } = auth
	const { globalProviderAttr, voucherTypeCancel } = tableCalls
	const {
		providerAttrList,
		providerAttrIndividualAccept,
		providerAttrGlobalAssignConfirmed,
		providerAttrGlobalAssignAborted,
		providerAttrGlobalAssigned,
		providerAttrEdit,
		providerAttrPagination
	} = providerAttrGlobalUpload
	return {
		config,
		authUser,
		fieldsConfig,
		providerAttrList,
		providerAttrIndividualAccept,
		providerAttrGlobalAssignConfirmed,
		providerAttrGlobalAssignAborted,
		providerAttrGlobalAssigned,
		globalProviderAttr,
		providerAttrEdit,
		providerAttrPagination,
		voucherTypeCancel
	}
}

const connectForm = connect(mapStateToProps, {
	getConfigVoucher,
	getConfigFieldsCrud,
	providerAttrGlobalAssign,
	providerAttrGlobalApply,
	providerAttrIndividualApply,
	providerAttrGlobalAssignConfirm,
	getTableGlobalProviderAttr,
	providerAttrGlobalAssignEdit,
	providerAttrGlobalAssignPaginate,
	providerCleanButton,
	voucherCancel
})(ProviderAttributesGlobalUpload)
export default withTranslation()(withRouter(connectForm))
